<script>
  import Credits from './Credits.svelte'
  import Layers from './Layers.svelte'
  import Nav from './Nav.svelte'
  import SelectDataset from './SelectDataset.svelte'

  import { datasets } from 'modules/stores.js'
</script>

<style>
  .sidebar {
    height: calc(100vh);
  }
  footer {
    margin-top: auto;
  }
</style>

<div class="sidebar d-flex flex-column p-3">
  <div class="pagehead mb-4">
    <h1>Gridify</h1>
  </div>

  <Layers datasets={$datasets} />

  <footer class="pt-6 pb-2">
    <Nav />
    <Credits />
  </footer>
</div>
